import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Radio } from 'antd';

import { CustomCollapseCard, Text } from '@src/components';
import { useMediaQuery } from '@src/hooks/useMediaQuery';

import { setPaymentType } from '@src/store/slice/mobilExpressSlice';
import {
  setTotalAutoLoading,
  updateAutoLoadingCommand,
} from '@src/store/slice/autoUploadInstructionsSlice';

import '@src/styles/autoUploadInstruction/paymentType.scss';

const PaymentType = () => {
  const isMobil = useMediaQuery({ query: '(max-width: 1199.98px)' });

  const dispatch = useDispatch();

  const { paymentType } = useSelector((state) => state?.mobilExpress);
  const { customerVou } = useSelector((state) => state?.customer);
  const { totalAutoLoading, autoLoadingId, integrationId } = useSelector(
    (state) => state?.autoUploadInstructions,
  );

  const updateLoadBalance = async (e) => {
    const value = e.target.value;

    await dispatch(
      setTotalAutoLoading({
        ...totalAutoLoading,
        paymentType: value === 1 ? 4 : 5,
      }),
    );

    const data = {
      periodType: totalAutoLoading?.periodType,
      confirmEveryMonth: totalAutoLoading?.confirmEveryMonth,
      startDay: totalAutoLoading?.startDay,
      isActive: autoLoadingId ? true : totalAutoLoading?.isActive,
      orderProcessType: totalAutoLoading?.orderProcessType,
      monthChoice: totalAutoLoading?.chooseMonth,
      paymentType: value === 1 ? 4 : 5,
    };

    if (autoLoadingId && autoLoadingId > 0) {
      data.id = autoLoadingId;
    }

    if (integrationId && integrationId > 0) {
      data.integrationId = integrationId;
    }

    const action = await dispatch(updateAutoLoadingCommand(data));

    if (updateAutoLoadingCommand.fulfilled.match(action)) {
      await dispatch(setPaymentType(value));
    }
  };

  useEffect(() => {
    setPaymentType(null);
  }, []);

  useEffect(() => {
    if (customerVou?.pamId === 4) {
      dispatch(setPaymentType(1));
    }
  }, [customerVou]);

  return (
    <CustomCollapseCard
      bodyCenter={!isMobil}
      cardTitle={<Text t="paymentTypeTitle" />}
      cardTitleAlign="left"
    >
      <Radio.Group
        id="ticketRestaurant-balanceUpload-payment-paymentType-custom-radioGroup-input-content"
        onChange={updateLoadBalance}
        value={paymentType}
        className="custom-radio-input-content"
      >
        {customerVou?.pamId === 4 && (
          <Radio
            id="ticketRestaurant-balanceUpload-payment-paymentType-custom-radio-input-content1"
            value={1}
            className={paymentType === 2 ? 'ant-radio-wrapper-unchecked' : null}
          >
            <div className="credit-card-title">
              <Text t="creditcard" />
            </div>
          </Radio>
        )}
        <Radio
          id="ticketRestaurant-balanceUpload-payment-paymentType-custom-radio-input-content2"
          value={2}
          className={paymentType === 1 ? 'ant-radio-wrapper-unchecked' : null}
        >
          <div className="eftTransfer-card-title">
            <Text t="eftTransfer" />
          </div>
        </Radio>
      </Radio.Group>
    </CustomCollapseCard>
  );
};

export default PaymentType;
